import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_arrow-top",
  "use": "svg_arrow-top-usage",
  "viewBox": "0 0 8 11",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 11\" id=\"svg_arrow-top\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.06.646a1.5 1.5 0 0 0-2.122 0L.292 3.293a1 1 0 1 0 1.414 1.414L3 3.413V10a1 1 0 1 0 2 0V3.415l1.292 1.292a1 1 0 1 0 1.414-1.414L5.06.646Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol